<div class="selector" *ngIf="values.length">
  <div class="choice">
    <div class="pill">
      <p
        *ngFor="let option of values"
        (click)="changeValue(option.value)"
        [class.active]="option.value === optionSelected"
      >
        {{ option.label }}
      </p>
    </div>
  </div>
</div>
